// import { makeURL } from '../../utils/Parents';

const isContent = item => !item.content && !['Lesson', 'Module'].includes(item.type);

function createContentArray(items, parents = []) {
    let array = [];
    for (let i = 0; i < items.length; i += 1) {
        const item = items[i];

        const parent = { id: item.id, type: item.type.toLowerCase() };
        const newParents = [...parents, parent];

        if (isContent(item)) array.push({ ...item, parents: newParents });
        else {
            const contentItems = createContentArray(item.content, newParents);
            array = [...array, ...contentItems];
        }
    }
    return array;
}

function formatSlug(parents) {
    const slug = {};

    for (let i = 0; i < parents.length; i += 1) {
        const parent = parents[i];
        slug[parent.type] = parent.id;
    }

    return slug;
}

export default {
    state: {
        loading: true,
        menuItems: [],
        menuIndex: 0,
        content: {},
        contentArray: [],
        contentIndex: null,
        contentItem: null,
        course: {},
        certificate: {},
        lesson: {},
        link: '',
        modal: {
            open: false,
            tab: 'description',
            id: null,
            type: '',
            description: '',
        },
        forum: null,
        exerciseError: '',
    },
    actions: {
        async CLASS_LOAD_MENU_ITEMS({ state, commit }, payload) {
            const { courseId, planId } = payload;

            await window.axios
                .get(`/api/plan/${planId}/course/${courseId}`)
                .then((res) => {
                    commit('SET_CLASS_MENU_ITEMS', res.data.data.content);

                    const contentArray = createContentArray(res.data.data.content, [
                        { type: 'course', id: state.course.id },
                    ]);
                    commit('SET_CLASS_CONTENT_ARRAY', contentArray);
                    commit('SET_CLASS_CONTENT_LINK', res.data.data.current_content.path);
                });
        },

        async CLASS_LOAD_CONTENT({ commit, state, dispatch }, payload) {
            commit('SET_CLASS_LOADING', true);
            const { iso, planId, courseId } = payload;

            if (planId !== undefined && courseId !== undefined) {
                await dispatch(
                    'CLASS_LOAD_MENU_ITEMS',
                    {
                        planId: planId,
                        courseId: courseId,
                    }
                );
            } 

            if (iso !== undefined) {
                window.axios
                    .get(`/${state.link}`, {
                        params: { iso },
                    })
                    .then(async (res) => {
                        commit('SET_CLASS_CONTENT', res.data.data);
                        commit('SET_CLASS_LOADING', false);
    
                        var content = state.contentArray.find(item => item.paths.current === state.link);
                        const index = state.contentArray.indexOf(content);

                        // Pega o id do plano baseado no path atual do conteúdo
                        const planId = parseInt(
                            content.paths.current.substring(
                                content.paths.current.indexOf('?plan=') + 6,
                                content.paths.current.indexOf('&course='),
                            )
                        ); 

                        // Adiciona o id do plano no array de parents
                        content.parents.unshift({
                            id: planId,
                            type: 'plan',
                        });

                        commit('SET_CLASS_CONTENT_ITEM', content);
                        commit('SET_CLASS_CONTENT_INDEX', index);
    
                        if (content.parents.some(p => p.type === 'course')) {
                            const courseParents = content.parents.filter(p => p.type === 'course');
                            const course = courseParents[courseParents.length - 1];
                            const courseProgress = await dispatch('CLASS_GET_COURSE_PROGRESS', course.id);
                            if (!courseProgress) return;
                            commit('SET_CLASS_COURSE_PROGRESS', courseProgress.progress.progress);

                            if (courseProgress.certificate !== null) {
                                commit('SET_CLASS_CERTIFICATE_PROGRESS', parseInt(courseProgress.certificate.progress));
                            }
                        }

                        if (content.parents.filter(p => p.type === 'lesson')) {
                            const lessonsParents = content.parents.filter(p => p.type === 'lesson');
                            const lastLesson = lessonsParents[lessonsParents.length - 1];
                            await commit('SET_CLASS_LESSON', { ...state.lesson, id: lastLesson.id });
                            await dispatch('CLASS_GET_LESSON', lastLesson.id);
                        } else {
                            commit('SET_CLASS_LESSON', { id: 0, progress: 0 });
                        }
                    })
                    .catch(err => console.error(err));            
            }
        },

        async CLASS_LOAD_FORUM({ state, commit }) {
            const { type, id } = state.modal;
            await window.axios
                .get(`/api/${type.toLowerCase()}/${id}/forum/certificate`)
                .then((res) => {
                    commit('SET_CLASS_FORUM', res.data.data.forum);
                });
        },

        CLASS_EXERCISE_SUBMIT_OPTION({ state }, payload) {
            const { questionId, answer } = payload;

            return window.axios
                .post(`/api/app/exercise/${state.content.exercise.id}/question/${questionId}/check`, {
                    answer,
                })
                .then(() => true)
                .catch((error) => {
                    console.error(error);
                    return false;
                });
        },

        CLASS_EXERCISE_SUBMIT({ commit, state, dispatch }, { forced } = {}) {
            if (!state.content.exercise || !state.content.exercise.id) return Promise.resolve();

            const slug = formatSlug(state.contentItem.parents);
            return window.axios
                .post(`/api/app/exercise/${state.content.exercise.id}/check`, {
                    slug,
                    forced: !!forced,
                })
                .then((res) => {
                    const { show_answer, progress, grade, grade_percentage, questions, finished } = res.data;
                    commit('SET_CLASS_EXERCISE', {
                        ...state.content.exercise,
                        grade,
                        progress,
                        finished,
                        questions,
                        show_answer,
                        grade_percentage,
                    });

                    dispatch('GET_CONTENT_PROGRESS');

                    if (state.content.exercise.started) {
                        commit('CLASS_EXERCISE_SET_TIME_STARTED', {
                            started: false,
                            started_confirmation: true,
                        });
                    }
                })
                .catch((err) => {
                    console.error(err);
                    return err;
                });
        },

        CLASS_EXERCISE_REDO({ commit, dispatch, state }) {
            return window.axios
                .get(`/api/app/exercise/${state.content.exercise.id}/redo`)
                .then((res) => {
                    commit('SET_CLASS_EXERCISE', {
                        ...state.content.exercise,
                        finished: false,
                        show_answer: null,
                        progress: null,
                        grade: null,
                        questions: res.data.questions,
                    });

                    dispatch('GET_CONTENT_PROGRESS');
                })
                .catch((err) => {
                    commit('SET_CLASS_EXERCISE_ERROR', err.response.data.error);
                });
        },

        CLASS_EXERCISE_GET_STUDENT_TIME({ commit, state, dispatch }) {
            return window.axios
                .get(`/api/app/exercise/${state.content.exercise.id}/time`)
                .then((res) => {
                    if (!res.data.student_time) {
                        return dispatch('CLASS_EXERCISE_SUBMIT', state.content.exercise.id);
                    }
                    commit('SET_CLASS_EXERCISE', {
                        ...state.content.exercise,
                        student_time: res.data.student_time,
                        started: true,
                        started_confirmation: true,
                    });
                    return null;
                })
                .catch(err => console.error(err));
        },

        CLASS_TOPIC_SUBMIT({ state, commit }, payload) {
            const { justify, answer, parents } = payload;
            return window.axios.post(`/api/app/topic/${state.content.topic.id}/answer/${answer}`, {
                justify,
                parents
            }).then((res) => {
                commit('SET_CLASS_TOPIC', res.data.data);
            });
        },

        async CLASS_GET_LESSON({ state, commit }, payload) {
            const id = payload;
            await window.axios
                .get(`/api/app/progress/lesson/${id}`)
                .then((res) => {
                    commit('SET_CLASS_LESSON', { ...state.lesson, progress: res.data.progress });
                })
                .catch(err => console.error(err));
        },

        async CLASS_GET_COURSE_PROGRESS({ state }, courseId) {
            // Ignorava o id recebido e usava state.course.id, que ainda não
            // está setado no momento desse dispatch em CLASS_LOAD_CONTENT —
            // batia no course errado/undefined e o progresso nunca atualizava.
            return window.axios
                .get(`/api/course/${courseId || state.course.id}/progress`)
                .then(res => res.data.data)
                .catch(err => console.error(err));
        },

        async CLASS_GET_EXERCISE_PROGRESS({ state, commit }) {
            return window.axios
                .get(`/api/exercise/${state.content.exercise.id}/progress`)
                .then((res) => {
                    commit('SET_CLASS_CONTENT_ITEM_PROGRESS', res.data.data.exercise.progress);
                })
                .catch(err => console.error(err));
        },
    },
    mutations: {
        SET_CLASS_COURSE: (state, payload) => { state.course = payload; },
        SET_CLASS_COURSE_PROGRESS: (state, payload) => { state.course.progress_value = payload; },
        SET_CLASS_CERTIFICATE_PROGRESS: (state, payload) => { state.course.certificateProgress = payload; },
        SET_CLASS_MENU_ITEMS: (state, payload) => { state.menuItems = payload; },
        INCREMENT_MENU_INDEX: (state) => { state.menuIndex += 1; },
        SET_CLASS_MODAL: (state, payload) => { state.modal = payload; },
        SET_CLASS_FORUM: (state, payload) => { state.forum = payload; },
        SET_CLASS_CONTENT: (state, payload) => { state.content = payload; },
        SET_CLASS_CONTENT_ARRAY: (state, payload) => { state.contentArray = payload; },
        SET_CLASS_CONTENT_ITEM: (state, payload) => { state.contentItem = payload; },
        SET_CLASS_CONTENT_ITEM_PROGRESS: (state, payload) => { state.contentItem.progress = payload; },
        SET_CLASS_CONTENT_INDEX: (state, payload) => { state.contentIndex = payload; },
        SET_CLASS_CONTENT_LINK: (state, payload) => { state.link = payload; },
        SET_CLASS_LOADING: (state, payload) => { state.loading = payload; },
        SET_CONTENT_TOPIC: (state, payload) => { state.topic = payload; },
        SET_FINAL_CONTENT: (state, payload) => { state.finalContent = payload; },
        SET_FINAL_CONTENT_TOPIC: (state, payload) => { state.topic = payload; },
        SET_FINAL_CONTENT_EXERCISE: (state, payload) => { state.content.exercise = payload; },

        CLEAR_CLASS_EXERCISE_ERROR: (state) => { state.error = ''; },
        SET_CLASS_EXERCISE_ERROR: (state, payload) => { state.error = payload; },
        SET_CLASS_EXERCISE: (state, payload) => { state.content.exercise = payload; },

        SET_CLASS_EXERCISE_STUDENT_TIME: (state) => {
            state.content.exercise.student_time -= 1;
        },

        CLASS_EXERCISE_SET_TIME_STARTED: (state, payload) => {
            state.content.exercise = {
                ...state.content.exercise,
                started: payload.started,
                started_confirmation: payload.started_confirmation,
            };
        },

        SET_CLASS_TOPIC: (state, payload) => { state.content.topic = payload; },

        SET_CLASS_LESSON: (state, payload) => { state.lesson = payload; },

        CLASS_SET_FILE_DOWNLOAD_STATUS(state, payload) {
            const { id, status } = payload;
            const newContent = state.content;

            newContent.files.forEach((file) => {
                if (file.id === id) {
                    file.download.status = status;
                }
            });

            state.content = { ...newContent };
        },
    },
    getters: {
        CLASS_LOADING: state => state.loading,
        CLASS_MENU_ITEMS: state => state.menuItems,
        CLASS_MENU_INDEX: state => state.menuIndex,

        CLASS_COURSE: state => state.course,
        CLASS_CONTENT: state => state.content,
        CLASS_EXERCISE: state => state.content.exercise,
        CLASS_TOPIC: state => state.content.topic,
        CLASS_LESSON: state => state.lesson,

        CLASS_CONTENT_ARRAY: state => state.contentArray,
        CLASS_CONTENT_ITEM: state => state.contentItem,
        CLASS_CONTENT_INDEX: state => state.contentIndex,

        CLASS_LINK: state => state.link,
        CLASS_MODAL: state => state.modal,
        CLASS_FORUM: state => state.forum,

        CLASS_EXERCISE_ERROR: state => state.content.exerciseError,
    },
};
